var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49291 1.41602C4.58291 1.41602 1.41666 4.58935 1.41666 8.49935C1.41666 12.4093 4.58291 15.5827 8.49291 15.5827C12.41 15.5827 15.5833 12.4093 15.5833 8.49935C15.5833 4.58935 12.41 1.41602 8.49291 1.41602ZM8.49999 14.166C5.36916 14.166 2.83332 11.6302 2.83332 8.49935C2.83332 5.36852 5.36916 2.83268 8.49999 2.83268C11.6308 2.83268 14.1667 5.36852 14.1667 8.49935C14.1667 11.6302 11.6308 14.166 8.49999 14.166Z",
    fill: "#255986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85416 4.95898H7.79166V9.20898L11.5104 11.4402L12.0417 10.569L8.85416 8.67773V4.95898Z",
    fill: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.ff4149743c8323226e3a242f12236df1.svg";
export { ForwardRef as ReactComponent };